export default __webpack_public_path__ + "static/media/logo_kcsit.93835a20.svg";